import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TreeView from 'portfolio-shared/view/Utilities/TreeView';

const { array, func, number, object, string } = PropTypes;

export default class PDLSubTree extends Component {
  static propTypes = {
    addSelectedPDLItems: func.isRequired,
    ancestorValues: array.isRequired,
    filterValue: string,
    itemSelectedStyle: string,
    itemStyle: string,
    level: number.isRequired,
    removeSelectedPDLItems: func.isRequired,
    selectedPDLItems: object.isRequired,
    setSelectedPDLItems: func.isRequired,
    submitFieldValue: func.isRequired,
    tree: object.isRequired,
  }

  constructor() {
    super();
    this.getSubtreeNodes = this.getSubtreeNodes.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.onClickTreeValue = this.onClickTreeValue.bind(this);
    this.onDoubleClickTreeValue = this.onDoubleClickTreeValue.bind(this);
  }

  getSubtreeNodes(node) {
    const result = [node];
    node.children && node.children.forEach(child => {
      result.push(child);
      result.push(...this.getSubtreeNodes(child));
    });
    return result;
  }

  onClickTreeValue(e) {
    const {
      addSelectedPDLItems,
      ancestorValues,
      removeSelectedPDLItems,
      setSelectedPDLItems,
      tree,
    } = this.props;
    e.preventDefault();
    e.stopPropagation();
    if (e.ctrlKey || e.metaKey) {
      if (this.isSelected()) {
        const nodes = this.getSubtreeNodes(tree);
        removeSelectedPDLItems(nodes);
      } else {
        addSelectedPDLItems(ancestorValues);
      }
    } else {
      setSelectedPDLItems(ancestorValues);
    }
  }

  async onDoubleClickTreeValue(e) {
    const {
      ancestorValues,
      selectedPDLItems,
      setSelectedPDLItems,
      submitFieldValue,
    } = this.props;
    setSelectedPDLItems(ancestorValues, e);
    // TODO: remove the async await when we fix PORT-10666
    for (const nestedValue of selectedPDLItems) {
      await submitFieldValue(nestedValue.value); // eslint-disable-line babel/no-await-in-loop
    }
  }

  isSelected() {
    const { ancestorValues, selectedPDLItems } = this.props;
    const ancestorIds = ancestorValues.map(v => v.id);
    const selectedIds = [...selectedPDLItems].map(v => v.id);
    return ancestorIds.every(id => selectedIds.includes(id));
  }

  render() {
    const {
      addSelectedPDLItems,
      ancestorValues,
      filterValue,
      itemSelectedStyle,
      itemStyle,
      level,
      removeSelectedPDLItems,
      selectedPDLItems,
      setSelectedPDLItems,
      submitFieldValue,
      tree,
    } = this.props;
    const computedItemStyle = this.isSelected() ? itemSelectedStyle : itemStyle;
    const indent = <div style={{ minWidth: level * 14 }} />;

    // no arrows for leaf nodes
    const arrowClassName = tree.children.length === 0 ?
      'tree-view_arrow-invisible' : null;

    if (!filterValue || tree.show) {
      return (
        <TreeView
          labelWrapper={children => ( // eslint-disable-line react/jsx-no-bind
            <div>
              {children}
            </div>
          )}
          className={arrowClassName}
          indent={indent}
          itemClassName={computedItemStyle}
          nodeLabel={tree.value}
          handleOnMouseDown={this.onClickTreeValue}
          handleOnDoubleClick={this.onDoubleClickTreeValue}
        >
          {tree.children ? tree.children.sort((a, b) => a.value.localeCompare(b.value)).map(
            childTree =>
              <PDLSubTree
                ancestorValues={ancestorValues.concat(childTree)}
                itemSelectedStyle={itemSelectedStyle}
                itemStyle={itemStyle}
                key={`PDL-${childTree.value}`}
                level={level + 1}
                selectedPDLItems={selectedPDLItems}
                setSelectedPDLItems={setSelectedPDLItems}
                addSelectedPDLItems={addSelectedPDLItems}
                removeSelectedPDLItems={removeSelectedPDLItems}
                submitFieldValue={submitFieldValue}
                tree={childTree}
                filterValue={filterValue}
              />
          ) : ''}
        </TreeView>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/Field/PDLSubTree.js